export const WEBSITE_STATUSES = [
  "Get in Contact",
  "Design",
  "Branding",
  "Content Writing",
  "Content Review",
  "Internal Review",
  "Adviser Review",
  "Development",
  "Live",
  "On Hold",
  "NPW"
].map((name) => ({ id: name, name }));

export const DOMAIN_REGISTRATION_TYPES = ["Registration", "Transfer"].map(
  (name) => ({ id: name, name }),
);

export const calculateAmountToCharge = (amountPaid, markup) => {
  if (String(amountPaid ?? "").trim() === "") return "";
  const paid = Number(amountPaid);
  const markupPercentage = String(markup ?? "").trim() === "" ? 0 : Number(markup);
  if (!Number.isFinite(paid) || !Number.isFinite(markupPercentage)) return "";
  return (paid * (1 + markupPercentage / 100)).toFixed(2);
};

export const EMPTY_DOMAIN = {
  domainName: "", registrationType: "", numberOfYears: "", registrar: "Namecheap",
  datePaid: "", amountPaid: "", paidBy: "", markup: "20", amountToCharge: "", notes: "",
  design: { liveDate: "", amountToCharge: "", chargeAcross: "" },
  hosting: { monthlyCharge: "" },
};

const today = new Date();
const TODAY_DATE_KEY = [
  today.getFullYear(),
  String(today.getMonth() + 1).padStart(2, "0"),
  String(today.getDate()).padStart(2, "0"),
].join("-");

export const EMPTY_WEBSITE = {
  dateStarted: TODAY_DATE_KEY, adviserName: "", adviserEmail: "",
  dateAdviserInformed: "", arTsName: "", estimatedTurnaroundDate: "",
  status: "", assignedTo: "", notes: "",
  websiteForm: null, domains: [{ ...EMPTY_DOMAIN }],
};
